var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-64, -280)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-copy",
    transform: "translate(64, 280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,5 C10.1045695,5 11,5.8954305 11,7 L11,13 C11,14.1045695 10.1045695,15 9,15 L3,15 C1.8954305,15 1,14.1045695 1,13 L1,7 C1,5.8954305 1.8954305,5 3,5 L9,5 Z M9,7 L3,7 L3,13 L9,13 L9,7 Z",
    id: "Rectangle",
    fill: "#7A858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,1 C14.1045695,1 15,1.8954305 15,3 L15,9 C15,10.1045695 14.1045695,11 13,11 L12,11 L12,9 L13,9 L13,3 L7,3 L7,4 L5,4 L5,3 C5,1.8954305 5.8954305,1 7,1 L13,1 Z",
    id: "Rectangle-Copy",
    fill: "#C5CDD3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ce331790be47a0ab48455f1fcd6548af.svg";
export { ForwardRef as ReactComponent };